<template>
  <div>
    <div class="" :class="btnPosition.btnHistoryClass || ''">
      <div
        :class="btnPosition.btnClass || ''"
        :style="btnPosition.btnStyle || ''"
        role="group"
      >
        <button class="btn btn-outline-primary next-btn" @click="previous">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
          {{ $t("global.return") }}
        </button>
        <button
          class="btn btn-primary wizard-btn next-btn"
          @click="nextStep"
          :disabled="!motif || motif.length === 0"
        >
          {{ $t("global.next") }}
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="card card-small mb-4 mt-3">
          <div class="card-body">
            <div class="select-date">
              <h6>
                {{ $t("simple.absence.request.fill.date") }}
                <sup class="text-red">*</sup>
              </h6>
            </div>

            <div class="row py-3">
              <div class="col-lg-12">
                <date-time
                  placeholder="Date d'absence"
                  @updateDate="updateDate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card card-small mb-4 mt-3">
          <div class="card-body">
            <h6>
              {{ $t("simple.absence.request.step.two.requesting.absence") }}
              <sup class="text-red">*</sup>
            </h6>
            <textarea
              v-model="motif"
              class="form-control col-md-12"
              cols="30"
              rows="7"
              :placeholder="$t('simple.absence.request.explain.here')"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="card card-small mb-4 mt-3">
      <div class="card-header inner-head border-bottom">
        <h6 class="inner-head__heading m-0">{{ $t('simple.absence.request.for') }} {{ user.lastName }} {{ user.firstName }}</h6>
      </div>
      <div class="card-body">
        <div class="py-2">
          <h5 class="mb-0 ml-3" style="color: #b6000a">{{ $t("simple.absence.request.step.two.title") }}</h5>
          <div class="row pl-3 pr-3">
            <div class="col-lg-12">
              <date-time placeholder="Date d'absence" @updateDate="updateDate"/>
            </div>
            <div class="col-lg-12 mt-1">
              <span class="font-weight-bold" style="color: #b6000a">Total d'heures: {{ totalHours }}</span>
            </div>
          </div>
          <div class="d-flex align-content-end mt-1" style="justify-content: flex-end;">
            <button class="btn btn-danger mr-3" @click="previous">{{ $t('global.return') }}</button>
            <button class="btn btn-success" @click="nextStep" :disabled="!model.date && totalHours > 0">{{ $t('global.next') }}</button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import TimeUtils from '../../../utils/TimeUtils';
import DateTime from '../../form/DateTime';

export default {
  name: 'StepTwoSimple',
  components: { DateTime },
  props: ['user', 'btnPosition'],
  data() {
    return {
      model: {
        startHour: '00',
        startMinute: '00',
        endHour: '00',
        endMinute: '00',
      },
      motif: null,
    };
  },
  computed: {
    totalHours() {
      let total = TimeUtils.getTimeDifference(
        {
          hour: this.model.startHour || 0,
          minute: this.model.startMinute || 0,
        },
        {
          hour: this.model.endHour || 0,
          minute: this.model.endMinute || 0,
        },
      ).toString();
      total = total.split('.');
      return `${total[0] === '0' ? '00' : total[0]}h${TimeUtils.formatMinutes(total[1])}`;
    },
  },
  methods: {
    updateDate(date) {
      this.model = date;
    },
    previous() {
      this.$emit('input', null);
    },
    nextStep() {
      this.$emit(
        'input',
        {
          from: TimeUtils.getDateFrom(
            this.model.date,
            this.model.startHour,
            this.model.startMinute,
          ),
          to: TimeUtils.getDateFrom(
            this.model.date,
            this.model.endHour,
            this.model.endMinute,
          ),
        },
        this.motif,
      );
    },
  },
};
</script>

<style scoped>
.btn.btn-outline-primary {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  color: #4f78e2;
  border-color: #4f78e2;
  box-shadow: none !important;
}

.btn.btn-outline-primary:hover {
  color: #4f78e2;
  border-color: #4f78e2;
  background-color: transparent;
}

.btn.btn-primary {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  color: #ffffff !important;
}

.text-red {
  color: red;
}

.heading-wrapper {
  position: absolute;
  top: 5px;
  right: 5px;
  text-align: center;
  background-color: #303778;
  padding: 15px 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 20px 0px #e9ecef;
  margin-bottom: 15px;
}

.heading-wrapper h5 {
  margin-bottom: 0;
  font-weight: bold;
  color: #ffffff;
}

.heading-wrapper span {
  color: #ffffff;
}

.heading-wrapper small {
  text-transform: uppercase;
}

.select-date {
  position: relative;
}

.new-date {
  color: #4f78e1;
  cursor: pointer;
}
</style>
